import { LayoutGrid, List } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const ICON_MAP: Record<string, React.ReactNode> = {
  grid: <LayoutGrid className="h-4 w-4" />,
  list: <List className="h-4 w-4" />,
};

interface ViewMode {
  mode: string;
  label: string;
  icon: string;
}

interface ViewModeSwitcherProps {
  modes: ViewMode[];
  current: string;
  onChange: (mode: string) => void;
  className?: string;
}

export function ViewModeSwitcher({ modes, current, onChange, className }: ViewModeSwitcherProps) {
  return (
    <div className={cn('flex items-center gap-1', className)}>
      {modes.map(({ mode, label, icon }) => (
        <Button
          key={mode}
          variant={current === mode ? 'secondary' : 'ghost'}
          size="sm"
          aria-label={label}
          aria-pressed={current === mode}
          onClick={() => onChange(mode)}
          className="h-8 w-8 p-0"
        >
          {ICON_MAP[icon] ?? <span className="text-xs">{label[0]}</span>}
        </Button>
      ))}
    </div>
  );
}
